import { environment } from '../../../../../environments/environment';

export const PhotoListComponent = {
  templateUrl: './app/ajs/_shared/components/photo-list/photo-list.component.html',
  bindings: {
    itemId: '=',
    items: '=',
    model: '@',
    onPhotosSaved: '&',
  },
  controller: PhotoListController,
  controllerAs: 'vm',
};

PhotoListController.$inject = ['UtilService', 'PhotoService'];

function PhotoListController(UtilService, PhotoService) {
  var vm = this;

  vm.UtilService = new UtilService(vm);

  var apiUrl = null;

  // Methods
  vm.changeItemStatus = changeItemStatus;
  vm.deleteItem = deleteItem;
  vm.openAddPhotosModal = openAddPhotosModal;

  vm.$onInit = function () {
    apiUrl = environment.apiEndpoint + vm.model + '/' + vm.itemId + '/photos';
  };

  function changeItemStatus(item) {
    vm.UtilService.changeItemStatus(apiUrl + '/' + item.id, item);
  }

  function deleteItem(item, index) {
    var successCallback = function (index) {
      vm.items.splice(index, 1);

      vm.onPhotosSaved({ photos: vm.items });
    };

    vm.UtilService.deleteItem(apiUrl + '/' + item.id, successCallback, {}, index);
  }

  function openAddPhotosModal() {
    var successCallback = function (data) {
      vm.onPhotosSaved({ photos: data });
    };

    PhotoService.openAddPhotosModal(apiUrl, vm.items, successCallback);
  }
}
